blue.ready("rotating-slider", ".rotating-slider", (slider) => {
  const displayImage = slider.querySelector("img.rotating-slider__img");
  const slides = slider.querySelectorAll("button.rotating-slider__slide");
  const prevButton = slider.querySelector(
    "button.rotating-slider__control.prev"
  );
  const nextButton = slider.querySelector(
    "button.rotating-slider__control.next"
  );
  const SLIDE_GAP = 4;
  const rail = slider.querySelector(".rotating-slider__rail");

  let lastTransform = 0;

  const handleSlideClick = (target) => {
    let newSrc = target.querySelector("img.rotating-slider__slide-img").src;
    displayImage.src = newSrc;
    slides.forEach((slide) => {
      slide.classList.remove("active");
    });
    target.classList.add("active");
  };

  const scrollNext = () => {
    if (nextButton.disabled) {
      return;
    }

    let slideWidth = slides[0].offsetWidth;
    let lastSlideRightEdge =
      slides[slides.length - 1].getBoundingClientRect().right;
    let railRightEdge = rail.getBoundingClientRect().right;

    if (lastSlideRightEdge - (slideWidth + SLIDE_GAP / 2) < railRightEdge) {
      lastTransform += lastSlideRightEdge - railRightEdge;
      nextButton.disabled = true;
    } else {
      lastTransform += slideWidth + SLIDE_GAP / 2;
    }

    slides.forEach((slide) => {
      slide.style.transform = `translateX(-${lastTransform}px)`;
    });

    prevButton.disabled = false;
  };

  const scrollPrev = () => {
    if (prevButton.disabled) {
      return;
    }

    let slideWidth = slides[0].offsetWidth;
    let firstSlideLeftEdge = slides[0].getBoundingClientRect().left;
    let railLeftEdge = rail.getBoundingClientRect().left;

    if (firstSlideLeftEdge + (slideWidth + SLIDE_GAP / 2) > railLeftEdge) {
      lastTransform -= railLeftEdge - firstSlideLeftEdge;
      prevButton.disabled = true;
    } else {
      lastTransform -= slideWidth + SLIDE_GAP / 2;
    }

    slides.forEach((slide) => {
      slide.style.transform = `translateX(-${lastTransform}px)`;
    });

    nextButton.disabled = false;
  };

  const init = () => {
    nextButton.addEventListener("click", scrollNext);

    prevButton.addEventListener("click", scrollPrev);

    if (slides.length < 5) {
      nextButton.disabled = true;
      nextButton.classList.add("hidden");
      prevButton.disabled = true;
      prevButton.classList.add("hidden");
    }

    slides.forEach((slide) => {
      slide.addEventListener("click", () => {
        handleSlideClick(slide);
      });
    });

    window.addEventListener("resize", () => {
      lastTransform = 0;
      slides.forEach((slide) => {
        slide.style.transform = `translateX(-${lastTransform}px)`;
      });
    });

    handleSlideClick(slides[0]);
  };

  init();
});
